import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import route from "./route-list";
import { trackPageImpression } from "@voyage-metrics/sdk";

const routes: Array<RouteRecordRaw> = route;

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const currentRefresh: string | null | undefined = localStorage.getItem("refreshToken");
  if (to.name !== "login" && !currentRefresh) {
    next("/");
    return;
  }
  next();
});

router.afterEach((to) => {
  trackPageImpression(to.path);
});

export default router;
